module.exports = __webpack_public_path__ + "static/media/host_command-addstar.15fbb4d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/host_command-addstar.svg
// module id = ./src/assets/images/host_command-addstar.svg
// module chunks = 0